import { useStyletron } from "baseui";
import { StyledLink } from "baseui/link";
import { HeadingSmall } from "baseui/typography";
import React from "react";
import { currentDocsArea } from "../chrome/DocsContext";
import { useDocsLocation } from "../chrome/nav/useDocsLocation";
import { ExampleFallbackAPIReferenceRelativeLink } from "../markdown-components/RelativeLinks";

const pages = [
  {
    area: "guides",
    content: (
      <>
        <StyledLink $style={{ textDecoration: "none" }} target="_blank" href="/guides">
          Guides
        </StyledLink>{" "}
        on how to build with Gadget
      </>
    ),
  },
  {
    area: "api",
    content: (
      <>
        <ExampleFallbackAPIReferenceRelativeLink path="/">API documentation</ExampleFallbackAPIReferenceRelativeLink> for your app
      </>
    ),
  },
  {
    area: "reference",
    content: (
      <>
        <StyledLink $style={{ textDecoration: "none" }} target="_blank" href="/reference">
          Reference
        </StyledLink>{" "}
        Gadget concepts & packages
      </>
    ),
  },
];

const LookingForSomethingElse = () => {
  const [css, $theme] = useStyletron();
  const [location] = useDocsLocation();
  const currentArea = currentDocsArea(location);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: $theme.sizing.scale500 }}>
      <HeadingSmall>Looking for something else?</HeadingSmall>
      <div style={{ display: "flex", flexDirection: "column", gap: $theme.sizing.scale400 }}>
        {pages
          .filter((page) => page.area != currentArea)
          .map((page, index) => (
            <div
              className={css({
                border: `1px solid ${$theme.colors.primary200}`,
                borderRadius: $theme.borders.radius300,
                padding: $theme.sizing.scale400,
                fontFamily: $theme.typography.font200.fontFamily,
              })}
              key={index}
            >
              <span>{page.content}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LookingForSomethingElse;
